import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import CrmLayout from '../../../components/CrmLayout';
import { Link, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import { Button, Radio, message } from 'antd';
import { CopyOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';
import { client_info, to_client_comments } from '../../../routes';
import cls from './ClientProject.module.scss';
import { Level } from '../../../components/Project/Level/Level';
import _ from 'lodash';
import cn from 'classnames';
import ImageUrl from '../../../helpers/ImageUrl';
import copyToClipboard from '../../../helpers/copyToClipboard';
import React, { useCallback, useEffect } from 'react';
import debounce from 'debounce-promise';
import { Comment } from '../Comment/Comment';
import { CommentSend } from '../Comment/CommentSend';

export function ClientProject() {

    const { id } = useParams();
    const [items, setItems] = React.useState([]);

    const [messageApi, contextHolder] = message.useMessage();
    const key = 'updatable';

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                limit: 1,
            },
        },
    });

    const type = query.data?.usersPermissionsUser?.data?.attributes?.client?.data ? 'child' : 'parent';

    const [updateMutation] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;
    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;

    useEffect(() => {
        setItems(client?.attributes?.projectData || [])
    }, [client?.attributes?.projectData])

    const debouncedUpdate = useCallback(
        debounce(async (latestItems) => {
            console.log('update...');
            await updateMutation({
                variables: {
                    id: client.id,
                    data: {
                        projectData: latestItems,
                    },
                },
                onCompleted: () => {
                    query.refetch()
                    messageApi.open({
                        key,
                        type: 'success',
                        content: 'Обновили',
                        duration: 2,
                    });
                }
            });
        }, 2000),
        [client] // Пустой массив зависимостей, функция создается один раз
    );

    if (!client) {
        return null;
    }

    const project = client?.attributes?.project?.data;

    if (!project) {
        return (
            <CrmLayout>
                <CrmCenteredTitle title={`${title} – Проект`} />

                <div className={cls.grid}>
                    <h3>У пользователя нет проекта</h3>
                    <span>Выбрать проект можно на странице клиента</span>
                    <Link to={client_info(id)}>
                        <Button type={'primary'} icon={<LeftOutlined />} size={'large'}>
                            Назад
                        </Button>
                    </Link>
                </div>
            </CrmLayout>
        );
    }

    const projectUrl = `${window.location.origin}/client-project/${query.data?.usersPermissionsUser?.data?.attributes?.publicKey}`;

    const mass = _.reduce(
        project.attributes?.experiences,
        (sum, item) => {
            // Проверяем, что list существует и это строка
            if (typeof item.list === 'string' && item.list.trim() !== '') {
                // Разделяем по \n и прибавляем количество получившихся элементов
                return sum + item.list.split('\n').length;
            }
            return sum;
        },
        0,
    );

    const toggleItem = (value, item) => {
        if (value) {
            const NewItems = [...items, item]
            setItems(NewItems)
            debouncedUpdate(NewItems)
        } else {
            const NewItems = items.filter(a => a !== item)
            setItems(NewItems);
            debouncedUpdate(NewItems)
        }
        messageApi.open({
            key,
            type: 'loading',
            content: 'Обновляем...',
            duration: 0,
        });
    }

    return (
        <CrmLayout>
            <CrmCenteredTitle title={`${title} – ${project.attributes?.name}`} />

            {contextHolder}

            <div className={cls.grid}>
                <div className={cn(cls.cover, cls.block)}
                     style={{
                         backgroundColor: project.attributes?.color,
                         backgroundImage: `url(${ImageUrl(project.attributes?.cover?.data?.attributes?.url)})`
                     }}
                >
                    {project.attributes?.logo?.data ?
                        <img className={cls.logo} src={ImageUrl(project.attributes?.logo?.data?.attributes?.url)}
                             alt={project.attributes?.name} />
                        :
                        <h3>{project.attributes?.name}</h3>}
                </div>

                {project.attributes?.levels?.length > 0 && (
                    <div className={cls.block}>
                        <Level
                            color={project.attributes?.color}
                            value={client.attributes?.projectData?.length || 0}
                            mass={mass}
                            levels={project.attributes?.levels}
                        />
                    </div>
                )}

                {_.map(project.attributes?.experiences, (group) => {
                    const list = group.list.trim().split('\n')
                    return (
                        <div className={cls.block} key={group.name}>
                            <h3>{group.name}</h3>
                            {group.description && <div>{group.description}</div>}
                            {_.map(list, (item) => (
                                <div key={item} className={cls.item}>
                                    <span>{item}</span>
                                    <div>
                                        <Radio.Group onChange={(e) => toggleItem(e.target.value, item)}
                                                     value={items.includes(item)} size={'large'} optionType={'button'}
                                                     buttonStyle={'solid'} options={[
                                            { value: false, label: 'Нет' },
                                            { value: true, label: 'Да' },
                                        ]} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )
                })}

                <div className={cls.block}>
                    <h3>
                        <Link to={to_client_comments(id)}>
                            Комментарии <Button type={'link'} icon={<RightOutlined />} />
                        </Link>
                    </h3>
                    {client.attributes?.messages?.data?.length > 0 && (
                        <Comment
                            createdAt={client.attributes?.messages?.data[0].attributes.createdAt}
                            firstName={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.firstName
                            }
                            lastName={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.lastName
                            }
                            url={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.avatar?.data?.attributes?.url
                            }
                            color={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.color
                            }
                            message={client.attributes?.messages?.data[0].attributes.message}
                        />
                    )}
                    <CommentSend id={client.id} onUpdate={() => query.refetch()} child={type === 'child'} />
                </div>

                <div className={cls.block}>
                    <h3>
                        <a href={projectUrl} target={'_blank'} rel={'noreferrer'}>
                            Страница проекта <Button type={'link'} icon={<RightOutlined />} />
                        </a>
                    </h3>
                    <div className={cls.url}>{projectUrl}</div>
                    <Button type={'link'} icon={<CopyOutlined />} onClick={() => copyToClipboard(projectUrl)}>
                        Скопировать
                    </Button>
                </div>
            </div>
        </CrmLayout>
    );
}
